export default function Minus({ className = "w-5 fill-current fill-ink" }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24">
      <path d="M0,13.5l0-3h24v3H0z" />
    </svg>
  )
}
